export const round = (number, decimals) => {
  const numberParsed = parseFloat(number);
  if (!number || isNaN(numberParsed)) return number;
  return parseFloat(numberParsed.toFixed(decimals || 2));
};

export const findUrlForMediaArray = (media, format) => {
  if (!media || !media.formatArray) return null;
  else if (!format) return media.url;

  const foundFormat = media?.formatArray.find(f => f.name === format);
  return foundFormat?.url || media.url;
};
